// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

export interface BasicUserInfo {
  email?: string;
  username?: string;
  displayName?: string;
  [claim: string]: unknown;
}

export interface DecodedIDTokenPayload {
  sub: string;
  email?: string;
  groups?: string[];
  exp: number;
  [claim: string]: unknown;
}

export type AlertType =
  | "REQUEST"
  | "SUBMIT"
  | "SAVE"
  | "DECLINE"
  | "END"
  | "CREATE";

export type stateType = "failed" | "success" | "loading" | "idle";

export enum Role {
  HR_ROLE = "HR_ROLE",
  MARKETING_ROLE = "MARKETING_ROLE",
  LEAD_ROLE = "LEAD_ROLE",
  EMPLOYEE_ROLE = "EMPLOYEE_ROLE",
  HIRING_MANAGER_ROLE = "HIRING_MANAGER_ROLE",
  ADMIN_ROLE = "ADMIN_ROLE",
}

export interface EmployeeInfo {
  employeeThumbnail: string;
  workEmail: string;
  firstName: string;
  lastName: string;
  lead: boolean;
  isRecruiter: boolean;
}

export type AuthFlowState =
  | "start"
  | "l_user_privileges"
  | "e_user_privileges"
  | "end";

export interface AuthState {
  status: "failed" | "loading" | "idle" | "success";
  statusMessage: string | null;
  isAuthenticated: boolean;
  userInfo: BasicUserInfo | null;
  employeeInfo: EmployeeInfo | null;
  employeeInfoRequestState: RequestState;
  idToken: string | null;
  isIdTokenExpired: boolean | null;
  decodedIdToken: DecodedIDTokenPayload | null;
  roles: Role[];
  userPrivileges: number[] | null;
  errorMessage: string | null;
  authFlowState: AuthFlowState;
}
export interface AuthData {
  userInfo: BasicUserInfo;
  idToken: string;
  decodedIdToken: DecodedIDTokenPayload;
}

export interface TokenResponse {
  access_token: string;
  expires_in: Number;
  id_token: string;
  issued_token_type: string;
  scope: string;
  refresh_token: string;
  token_type: string;
}

export interface Header {
  title: string;
  size: number;
  align: "left" | "right" | "center";
}

export enum RequestState {
  IDLE = "idle",
  LOADING = "loading",
  SUCCEEDED = "succeeded",
  FAILED = "failed",
}

export interface Location {
  country: string;
  id: number;
  offices: Office[];
}

interface Office {
  office: string;
  id: number;
}

export type JobJsonObject = {
  mainContent: string;
  taskInformation: string | null;
  additionalContent: string | null;
};

type HtmlSection = {
  title: string;
  value: string;
};
